var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.name,{tag:"component",attrs:{"types":_vm.type,"activeName":_vm.activeName,"dataIds":_vm.dataId,"montype":_vm.montype,"cityId":_vm.cityId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }